import React from "react";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IGameLoadingIndicatorModel} from "./game-loading-indicator-model.interface";

export abstract class GameLoadingIndicatorBaseModel implements IGameLoadingIndicatorModel {
    constructor(protected readonly services: IServiceFactoryExtended) {
    }

    abstract render(): React.ReactElement;

    get isHidden(): boolean {
        return this.services.dialog.hasOpenDialogs || this.services.sdk.hasOpenOverlays;
    }

    dispose(): void {

    }
}